import { ChangeDetectorRef, Component, OnInit, ViewChild, WritableSignal, AfterViewInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BreadcrumbService } from '../../../app.breadcrumb.service';
import { MessageService, ConfirmationService, SortEvent, MenuItem } from 'primeng/api';
import { ProfilService } from 'src/app/services/profil-service';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppMainComponent } from 'src/app/app.main.component';
import { HeureService } from 'src/app/services/heure-service';
import { SuiviHeuresEntite } from 'src/app/entites/suivi-heures';
import { Table } from 'primeng/table';
import { Menu } from 'primeng/menu';
import { ItemService } from 'src/app/services/item-service';
import { SuiviKmsEntite } from 'src/app/entites/suivi-kms';
import { KmService } from 'src/app/services/km-service';

@Component({
    templateUrl: './suivi-heureskms.component.html',
    providers: [MessageService, ConfirmationService]
})
export class SuiviHeuresKmsComponent extends BaseComponent implements OnInit, AfterViewInit {

    suiviHeures: SuiviHeuresEntite[] = [];
    suiviKms: SuiviKmsEntite[] = [];
    loading: boolean = true;
    chartData: any;
    chartOptions: any;

    activeTab = this.createParamSignal('tab', 'heures');

    contenuMenuContextuelSuiviHeures: MenuItem[] = [];
    items: MenuItem[] = [
        { id: 'heures', label: 'Suivi des heures', icon: 'pi pi-clock', command: () => this.changeTab('heures') },
        { id: 'km', label: 'Suivi des km', icon: 'pi pi-road', command: () => this.changeTab('km') }
    ];
    activeItem: MenuItem;

    multiSortMeta: any[] = [
        { field: 'differenceJours', order: 1 },
        { field: 'item.numero', order: 1 }
    ];

    orderByDifferenceOptions = [
        { label: 'Jours ascendant', value: 'differenceJours', order: 1 },
        { label: 'Jours descendant', value: 'differenceJours', order: -1 },
        { label: 'Heures ascendant', value: 'differenceHeures', order: 1 },
        { label: 'Heures descendant', value: 'differenceHeures', order: -1 },
    ];
    selectedOrderByDifference: any = { label: 'Jours ascendant', value: 'differenceJours', order: 1 };

    filtreSansReleveRecent: boolean = false;
    filtreAvecLocation: boolean = false;

    @ViewChild('dt') dt: Table;
    @ViewChild('menuContextuelSuiviHeures') menuContextuelSuiviHeures: Menu;

    filtreOptionsDifference: any[] = [];
    selectedDifferenceFilter: any;

    constructor(
        public sdb: DonneesBaseService,
        public profilService: ProfilService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public route: ActivatedRoute,
        public routerService: Router,
        public appMain: AppMainComponent,
        private heureService: HeureService,
        private kmService: KmService,
        private itemService: ItemService,
        private ref: ChangeDetectorRef
    ) {
        super(sdb, profilService, route, routerService, appMain);
        this.breadcrumbService.setItems([
            { label: 'Suivi des heures' }
        ]);
    }

    ngOnInit() {
        this.activeItem = this.items.find(item => item.id === this.activeTab());
        this.initializeColumns();
        this.chargerDonnees();
        this.updateOrderByDifference();
        this.ref.detectChanges();
    }

    ngAfterViewInit() {
        this.chargerColonnesSelectionnees();
    }

    initializeColumns() {
        this.colonnesDisponibles = [
            { champ: 'numero', entete: 'Numéro', afficheParDefaut: true },
            { champ: 'description', entete: 'Description', afficheParDefaut: true },
            { champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
            { champ: 'emplacement', entete: 'Emplacement', afficheParDefaut: true },
            { champ: 'dateDebut', entete: 'Date début', afficheParDefaut: true },
            { champ: 'avantDerniereLecture', entete: 'Avant-dernière lecture', afficheParDefaut: true },
            { champ: 'derniereLecture', entete: 'Dernière lecture', afficheParDefaut: true },
            { champ: 'difference', entete: 'Différence', afficheParDefaut: true },
            { champ: 'location', entete: '|Location|', afficheParDefaut: true },
            { champ: 'dateDebutLocation', entete: 'Date début location', afficheParDefaut: true },
            { champ: 'dateFinLocation', entete: 'Date fin location', afficheParDefaut: true },
            { champ: 'heuresDebut', entete: 'Heures début', afficheParDefaut: true },
            { champ: 'fournisseur', entete: 'Fournisseur', afficheParDefaut: true },
            { champ: 'typeLocation', entete: 'Type location', afficheParDefaut: true },
            { champ: 'nbHeuresParMois', entete: 'Heures/mois', afficheParDefaut: true }
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(col => col.afficheParDefaut);

    }

    changeTab(tab: string) {
        this.activeTab.set(tab);

        this.updateOrderByDifference();
        if ((tab === 'heures' && this.suiviHeures.length === 0) || (tab === 'km' && this.suiviKms.length === 0)) {
            this.chargerDonnees();
        } else {
            if (tab === 'heures') {
                this.prepareChartData();
            } else {
                this.prepareChartDataKms();
            }
        }

        this.dt.reset();
    }

    updateOrderByDifference() {
        if (this.activeTab() === 'km') {
            this.orderByDifferenceOptions[2] = { label: 'Kms ascendant', value: 'differenceKms', order: 1 };
            this.orderByDifferenceOptions[3] = { label: 'Kms descendant', value: 'differenceKms', order: -1 };
        } else {
            this.orderByDifferenceOptions[2] = { label: 'Heures ascendant', value: 'differenceHeures', order: 1 };
            this.orderByDifferenceOptions[3] = { label: 'Heures descendant', value: 'differenceHeures', order: -1 };
        }
    }

    isColumnVisible(field: string): boolean {
        return this.selectedColumns.some(col => col.field === field);
    }

    onToggle() {
        this.ref.detectChanges();
    }

    chargerDonnees() {
        this.loading = true;
        if (this.activeTab() === 'heures') {
            this.heureService.ObtenirSuiviHeures()
                .subscribe({
                    next: (data: SuiviHeuresEntite[]) => {
                        this.suiviHeures = data;
                        this.loading = false;
                        this.suiviHeures.forEach(suivi => {
                            suivi.differenceJours = this.calculerDifferenceJours(suivi);
                            suivi.differenceHeures = this.calculerDifferenceHeures(suivi);
                        });
                        this.prepareChartData();
                    },
                    error: (error) => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors du chargement des données' });
                        this.loading = false;
                    }
                });
        } else {
            this.kmService.ObtenirSuiviKms()
                .subscribe({
                    next: (data: SuiviKmsEntite[]) => {
                        this.suiviKms = data;
                        this.loading = false;
                        this.suiviKms.forEach(suivi => {
                            suivi.differenceJours = this.calculerDifferenceJours(suivi);
                            suivi.differenceKms = this.calculerDifferenceKms(suivi);
                        });
                        this.prepareChartDataKms();
                    },
                    error: (error) => {
                        this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors du chargement des données' });
                        this.loading = false;
                    }
                });
        }
    }

    calculerDifferenceHeures(suivi: SuiviHeuresEntite): number {
        return (suivi.heuresDernierePrise || 0) - (suivi.heuresAvantDernierePrise || 0);
    }

    calculerDifferenceKms(suivi: SuiviKmsEntite): number {
        return (suivi.kmsDernierePrise || 0) - (suivi.kmsAvantDernierePrise || 0);
    }

    getClassDifference(difference: number): string {
        if (difference > 0) {
            return 'text-green-500';
        } else if (difference < 0) {
            return 'text-red-500';
        }
        return '';
    }

    getStatusSeverity(difference: number): string {
        if (difference > 100) {
            return 'success';
        } else if (difference > 50) {
            return 'info';
        } else if (difference > 0) {
            return 'warning';
        } else {
            return 'danger';
        }
    }

    getNombreItemsProblematiques(): number {
        return this.suiviHeures.filter(s => this.calculerDifferenceHeures(s) <= 0).length;
    }

    getNombreItemsAttention(): number {
        return this.suiviHeures.filter(s => {
            const diff = this.calculerDifferenceHeures(s);
            return diff > 0 && diff <= 50;
        }).length;
    }

    getNombreItemsBons(): number {
        return this.suiviHeures.filter(s => {
            const diff = this.calculerDifferenceHeures(s);
            return diff > 50 && diff <= 100;
        }).length;
    }

    getNombreItemsNormaux(): number {
        return this.suiviHeures.filter(s => this.calculerDifferenceHeures(s) > 100).length;
    }

    getTotalHeures(): number {
        return this.suiviHeures.reduce((total, suivi) => total + suivi.heuresDernierePrise, 0);
    }

    EstCharge(): boolean {
        return !this.loading;
    }

    estAutorise(tache: string) {
        return this.profilService.estAutoriseTache(tache);
    }

    estDernierePriseAncienne(suivi: SuiviHeuresEntite): boolean {
        if (!suivi.dateDernierePrise) {
            return true; // If no date is set, consider it as old
        }

        const dernierePrise = new Date(suivi.dateDernierePrise);
        const aujourdhui = new Date();
        const differenceEnJours = Math.floor((aujourdhui.getTime() - dernierePrise.getTime()) / (1000 * 3600 * 24));

        return differenceEnJours > 10;
    }

    estDernierePriseAncienneKms(suivi: SuiviKmsEntite): boolean {
        if (!suivi.dateDernierePrise) {
            return true; // If no date is set, consider it as old
        }

        const dernierePrise = new Date(suivi.dateDernierePrise);
        const aujourdhui = new Date();
        const differenceEnJours = Math.floor((aujourdhui.getTime() - dernierePrise.getTime()) / (1000 * 3600 * 24));

        return differenceEnJours > 10;
    }

    getNombreItemsSansReleveRecent(): number {
        return this.suiviHeures.filter(s => this.estDernierePriseAncienne(s)).length;
    }

    getNombreItemsSansReleveRecentKms(): number {
        return this.suiviKms.filter(s => this.estDernierePriseAncienneKms(s)).length;
    }

    getNombreItemsAvecLocation(): number {
        return this.suiviHeures.filter(s => s.location && s.location.dateDebut).length;
    }

    calculerHeuresMoyennes(): number {
        if (this.suiviHeures.length === 0) return 0;

        const totalHeures = this.suiviHeures.reduce((total, suivi) => {
            if (suivi.differenceHeures !== undefined && suivi.differenceHeures !== null && suivi.differenceHeures !== 0) {
                return total + suivi.differenceHeures;
            }
            return total;
        }, 0);

        return totalHeures / this.suiviHeures.length;
    }

    calculerKmsMoyens(): number {
        if (this.suiviKms.length === 0) return 0;

        const totalKms = this.suiviKms.reduce((total, suivi) => {
            if (suivi.differenceKms !== undefined && suivi.differenceKms !== null && suivi.differenceKms !== 0) {
                return total + suivi.differenceKms;
            }
            return total;
        }, 0);

        return totalKms / this.suiviKms.length;
    }
    
    prepareChartData() {
        // Créer des catégories pour les différences d'heures
        const differences = this.suiviHeures.map(s => this.calculerDifferenceHeures(s));

        // Catégories pour le graphique: Négatif, 0-50, 51-100, >100
        const zero = differences.filter(d => d == 0).length;
        const petit = differences.filter(d => d > 0 && d <= 25).length;
        const moyen = differences.filter(d => d > 25 && d <= 50).length;
        const grand = differences.filter(d => d > 50 && d <= 100).length;
        const plus = differences.filter(d => d > 100).length;

        this.chartData = {
            labels: ['0h', '0-25h', '26-50h', '51-100h', '>100h'],
            datasets: [
                {
                    label: 'Équipements',
                    backgroundColor: ['#ffd9d9', '#ffe7b3', '#d9e6ff', '#d4f5e6', '#e6f5ff'],
                    borderColor: ['#fca5a5', '#fcd34d', '#93c5fd', '#6ee7b7', '#7dd3fc'],
                    borderWidth: 1,
                    data: [zero, petit, moyen, grand, plus]
                }
            ]
        };

        this.chartOptions = {
            plugins: {
                legend: {
                    display: false
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        precision: 0
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false
        };
    }

    prepareChartDataKms() {
        const differences = this.suiviKms.map(s => this.calculerDifferenceKms(s));

        const zero = differences.filter(d => d == 0).length;
        const petit = differences.filter(d => d > 0 && d <= 100).length;
        const moyen = differences.filter(d => d > 100 && d <= 500).length;
        const grand = differences.filter(d => d > 500 && d <= 1000).length;
        const plus = differences.filter(d => d > 1000).length;

        this.chartData = {
            labels: ['0km', '0-100km', '101-500km', '501-1000km', '>1000km'],
            datasets: [
                {
                    label: 'Équipements',
                    backgroundColor: ['#ffd9d9', '#ffe7b3', '#d9e6ff', '#d4f5e6', '#e6f5ff'],
                    borderColor: ['#fca5a5', '#fcd34d', '#93c5fd', '#6ee7b7', '#7dd3fc'],
                    borderWidth: 1,
                    data: [zero, petit, moyen, grand, plus]
                }
            ]
        };

        this.chartOptions = {
            plugins: {
                legend: {   
                    display: false
                }
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        precision: 0
                    }
                }
            },
            responsive: true,
            maintainAspectRatio: false
        };
    }

    filtrerSansReleveRecent(table: any) {
        this.filtreSansReleveRecent = true;
        this.filtreAvecLocation = false;

        // Filtrer la table pour montrer uniquement les éléments sans relevé récent
        table.filteredValue = this.suiviHeures.filter(suivi => this.estDernierePriseAncienne(suivi));
    }

    filtrerAvecLocation(table: any) {
        this.filtreSansReleveRecent = false;
        this.filtreAvecLocation = true;

        // Filtrer la table pour montrer uniquement les éléments avec location
        table.filteredValue = this.suiviHeures.filter(suivi => suivi.location && suivi.location.locationId);
    }

    reinitialiserFiltreSansReleveRecent(table: any) {
        this.filtreSansReleveRecent = false;
        this.filtreAvecLocation = false;
        this.chargerDonnees();
    }

    reinitialiserFiltreAvecLocation(table: any) {
        this.filtreSansReleveRecent = false;
        this.filtreAvecLocation = false;
        this.chargerDonnees();
    }

    calculerDifferenceJours(suivi: any): number {
        if (!suivi.dateAvantDernierePrise || !suivi.dateDernierePrise) {
            return 0;
        }

        const dateAvant = new Date(suivi.dateAvantDernierePrise);
        const dateDerniere = new Date(suivi.dateDernierePrise);

        // Calculate difference in days
        const diffTime = Math.abs(dateDerniere.getTime() - dateAvant.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        return diffDays;
    }

    onDifferenceFilterChange(event: any) {
        this.selectedOrderByDifference = event.value;
        this.multiSortMeta = [{ field: this.selectedOrderByDifference.value, order: this.selectedOrderByDifference.order }];
    }

    surMenuContextuelSuivi(suivi: any) {
        this.contenuMenuContextuelSuiviHeures = [
            {
                label: 'Voir l\'emplacement',
                icon: 'pi pi-eye',
                command: () => this.routerService.navigate(['/emplacement', suivi.item?.emplacement?.emplacementId])
            },
            {
                label: 'Voir l\'équipement',
                icon: 'pi pi-eye',
                command: () => this.routerService.navigate(['/item', suivi.item?.itemId])
            },
            {
                label: 'Voir la location',
                icon: 'pi pi-eye',
                visible: suivi.location != null && suivi.location.locationId != null,
                command: () => this.routerService.navigate(['location', suivi.location?.locationId])
            },
            {
                label: 'Ne plus afficher dans ce rapport',
                icon: 'pi pi-times',
                command: () => this.activeTab() === 'heures' ? this.nePlusAfficherDansCeRapport(suivi) : this.nePlusAfficherDansCeRapportKm(suivi)
            }
        ];
        this.menuContextuelSuiviHeures.toggle(event);
    }

    nePlusAfficherDansCeRapport(suivi: SuiviHeuresEntite) {
        this.itemService.ObtenirItem(suivi.item.itemId).subscribe(item => {
            item.value().indIgnorerRapportHeures = true;
            this.itemService.ModifierItem(item.value()).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'équipement a été ignoré dans ce rapport' });
                this.suiviHeures = this.suiviHeures.filter(s => s.item.itemId !== suivi.item.itemId);
            });
        });
    }

    nePlusAfficherDansCeRapportKm(suivi: SuiviKmsEntite) {
        this.itemService.ObtenirItem(suivi.item.itemId).subscribe(item => {
            item.value().indIgnorerRapportKms = true;
            this.itemService.ModifierItem(item.value()).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'équipement a été ignoré dans ce rapport' });
                this.suiviKms = this.suiviKms.filter(s => s.item.itemId !== suivi.item.itemId);
            });
        });
    }
    
    get numberOfLocationColumns(): number {
        return this.colonnesSelectionnees.filter(col => col.champ.includes('dateDebutLocation') || col.champ.includes('dateFinLocation') || col.champ.includes('heuresDebut') || col.champ.includes('fournisseur') || col.champ.includes('typeLocation') || col.champ.includes('nbHeuresParMois')).length;
    }
} 